// @flow

export const RESIZE: 'features.brightbox.com/resize' = 'features.brightbox.com/resize';
export const CLUSTER_IPS: 'features.brightbox.com/cluster_ips' = 'features.brightbox.com/cluster_ips';
export const NBS: 'features.brightbox.com/nbs' = 'features.brightbox.com/nbs';

export type Feature = typeof RESIZE | typeof CLUSTER_IPS | typeof NBS;
